'use strict';

var d3 = require('d3');
var ProfileChart = function ProfileChart(AbstractProfileChart, chartZoom, chartRectClip, chartPinLine, $location) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var self = this;
    AbstractProfileChart.call(this, container, formatters);
    var params = chartParams(this.axisDirection);
    var dispatch = d3.dispatch('pindown');
    d3.rebind(this, dispatch, 'on');
    this.pinLine = chartPinLine().params(this.params).scales(this.scales);
    this.pinLine.on('pindown', function (daysToDeparture) {
      dispatch.pindown(daysToDeparture);
    });
    var clipPathId = 'profile-chart-clip';
    var clipPath = $location.path() + '#' + clipPathId;
    this.render = function (data, range) {
      d3.select('#' + clipPathId).remove();
      this.initChart(data, range, params);
      this.scales = chartScales(this.params, this.data, this.axisDirection);
      var zoom = chartZoom();
      var rectClip = chartRectClip();
      this.svg.call(rectClip.id(clipPathId).x(0).y(-this.params.padding.bottom).width(this.container.width() - this.params.padding.right).height(this.container.height()));
      var chartElements = [this.yAxis.withoutHorizontalLines(), this.curves.clipPath(clipPath), this.squareIndicators.clipPath(clipPath), this.hoverOver, this.xAxis, this.pinLine.clipPath(clipPath)];
      this.callForDataGroup(chartElements, this.scales);
      var redrawElementsWrapper = function redrawElementsWrapper() {
        var redrawElements = [self.curves, self.squareIndicators, self.xAxis, self.hoverOver, self.pinLine];
        self.callForDataGroup.call(self, redrawElements);
      };
      this.svg.call(zoom.params(this.params).scales(this.scales).toRedraw([redrawElementsWrapper.bind(this)]));
    };
    this.setSelectedDtd = function (dtd) {
      this.pinLine.setSelectedDtd(dtd);
      return this;
    };
  };
  Chart.prototype = Object.create(AbstractProfileChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ProfileChart.$inject = ['AbstractProfileChart', 'ChartElementsZoom', 'ChartElementsRectClip', 'ChartElementsPinLine', '$location'];
module.exports = ProfileChart;